<template>
  <div class="info-box">
    <div class="flex-1 overflow-y-auto gap-x-3">
      <el-form
        :model="state.model"
        label-width="auto"
        label-position="top"
        ref="formDom"
        size="large"
        class="px-2.5"
      >
        <el-form-item label="状态">
          <el-switch
            v-model="state.model.status"
            active-text="启用"
            inactive-text="禁用"
            inline-prompt
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
        <ul class="grid gap-x-5" style="grid-template-columns: 1fr 100px 100px">
          <el-form-item
            label="房型名称"
            prop="name"
            :rules="[
              { required: true, message: '请输入房型名称', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.name"></el-input>
          </el-form-item>
          <el-form-item
            label="入住人数"
            prop="guest_num"
            :rules="[
              { required: true, message: '请输入入住人数', trigger: 'blur' },
            ]"
          >
            <el-input-number
              v-model="state.model.guest_num"
              :min="1"
              precision="0"
            />
          </el-form-item>
          <el-form-item
            label="房型数量"
            prop="count"
            :rules="[
              { required: true, message: '请输入房型数量', trigger: 'blur' },
            ]"
            class="min-w-0"
          >
            <el-input-number
              v-model="state.model.count"
              :min="1"
              precision="0"
            />
          </el-form-item>
        </ul>
        <el-form-item label="房型说明">
          <el-input
            v-model="state.model.intro"
            type="textarea"
            :autosize="{ minRows: 10 }"
            size="large"
          />
        </el-form-item>
        <el-form-item label="附件">
          <c_UploadFile
            :key="state.model.id"
            :value="state.model.files"
            @change="
              (data) => {
                state.model.files = data;
              }
            "
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="submit-box px-2.5">
      <el-button type="primary" @click="onSubmit"> 提交 </el-button>
    </div>
    <el-image-viewer
      v-if="state.showPreview"
      :url-list="state.model.files?.map((m) => m.file_url)"
      show-progress
      :initial-index="4"
      @close="state.showPreview = false"
    />
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  hotel_roomtype_detail,
  hotel_roomtype_add,
  hotel_roomtype_edit,
} from "@/http/hotel";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
    hotel_id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        hotel_id: props.hotel_id,
        status: 1,
        files: [],
      },
    });
    onMounted(() => {
      if (props.id) {
        hotel_roomtype_detail(props.id).then((res) => {
          if (res.status == 200) {
            const data = res.data?.data;
            state.model = data;
            state.model.files = data.attachment || [];
          }
        });
      }
    });

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          state.model.attachment_img = JSON.stringify(
            state.model.files?.map((m) => m.id),
          );
          if (props.id) {
            hotel_roomtype_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            hotel_roomtype_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
